export const LAUNCH_DARKLY_INIT = 'LAUNCH_DARKLY_INIT'
export const LAUNCH_DARKLY_INIT_FULFILLED = 'LAUNCH_DARKLY_INIT_FULFILLED'
export const LAUNCH_DARKLY_INIT_REJECTED = 'LAUNCH_DARKLY_INIT_REJECTED'
export const LAUNCH_DARKLY_READY = 'LAUNCH_DARKLY_READY'
export const LAUNCH_DARKLY_READY_FULFILLED = 'LAUNCH_DARKLY_READY_FULFILLED'
export const LAUNCH_DARKLY_READY_REJECTED = 'LAUNCH_DARKLY_READY_REJECTED'
/**
 * User object for launch darkly
 * @typedef {object} LaunchDarklyUser
 * @property {string} key - user email
 * @property {boolean} [anonymous] - whether the user is an anonymous user
 */
/**
 * @typedef {object} InitPayload
 * @property {string} id - Launch Darkly app id
 * @property {LaunchDarklyUser} user - current user
 */
/**
 * Initialize the launch darkly client
 * @param {InitPayload} payload
 */
export const init = (payload) => ({ type: LAUNCH_DARKLY_INIT, payload })

export const LAUNCH_DARKLY_GET_FEATURE_FLAG = 'LAUNCH_DARKLY_GET_FEATURE_FLAG'
export const LAUNCH_DARKLY_GET_FEATURE_FLAG_REJECTED =
  'LAUNCH_DARKLY_GET_FEATURE_FLAG_REJECTED'
export const LAUNCH_DARKLY_UPDATE_FEATURE_FLAGS =
  'LAUNCH_DARKLY_UPDATE_FEATURE_FLAGS'
/**
 * Retrieve one flag
 * @param {{featureFlag: {string}}} payload - featureFlag is the name of the flag to retrieve
 */
export const getFeatureFlag = (payload) => ({
  type: LAUNCH_DARKLY_GET_FEATURE_FLAG,
  payload,
})

export const LAUNCH_DARKLY_GET_ALL_FEATURE_FLAGS =
  'LAUNCH_DARKLY_GET_ALL_FEATURE_FLAGS'
export const LAUNCH_DARKLY_GET_ALL_FEATURE_FLAGS_REJECTED =
  'LAUNCH_DARKLY_GET_ALL_FEATURE_FLAGS_REJECTED'
/**
 * Retrieve all feature flags
 */
export const getAllFeatureFlags = () => ({
  type: LAUNCH_DARKLY_GET_ALL_FEATURE_FLAGS,
})

export const LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS =
  'LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS'
export const LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS_FULFILLED =
  'LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS_FULFILLED'
export const LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS_REJECTED =
  'LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS_REJECTED'
/**
 * Subscribe to changes for all feature flags
 */
export const subscribeAllFeatureFlags = () => ({
  type: LAUNCH_DARKLY_SUBSCRIBE_ALL_FEATURE_FLAGS,
})

export const LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG =
  'LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG'
export const LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG_FULFILLED =
  'LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG_FULFILLED'
export const LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG_REJECTED =
  'LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG_REJECTED'
/**
 * Subscribe to changes for a specific feature flag
 * @param {{featureFlag: {string}}} payload - featureFlag is the specific flag to subscibe to
 */
export const subscribeSpecificFeatureFlag = (payload) => ({
  type: LAUNCH_DARKLY_SUBSCRIBE_SPECIFIC_FEATURE_FLAG,
  payload,
})

export const LAUNCH_DARKLY_IDENTIFY_USER = 'LAUNCH_DARKLY_IDENTIFY_USER'
export const LAUNCH_DARKLY_IDENTIFY_USER_FULFILLED =
  'LAUNCH_DARKLY_IDENTIFY_USER_FULFILLED'
export const LAUNCH_DARKLY_IDENTIFY_USER_REJECTED =
  'LAUNCH_DARKLY_IDENTIFY_USER_REJECTED'
/**
 * Update the current user
 * @param {{user: LaunchDarklyUser}} payload
 */
export const identifyUser = (payload) => ({
  type: LAUNCH_DARKLY_IDENTIFY_USER,
  payload,
})
